export default {
  hero: {
    title: 'お問い合わせ',
    subtitle: 'デジタルな未来を共に創造しましょう'
  },
  
  // 7つのサービス地域
  serviceRegions: {
    title: '7つのサービス地域',
    subtitle: 'アジア太平洋地域全域にわたる専門サービスチームで、地域密着型サポートを提供',
    officeAddress: 'サービスセンター',
    phone: '電話番号',
    email: 'メールアドレス',
    workingHours: '営業時間',
    officeHoursNote: '具体的な対応体制は地域とサービスレベルに応じて調整可能です。',
    noOfficeInfo: 'この地域のサービスセンター情報は確認待ちです。まずはメールでお問い合わせください。',
    regions: {
      china: {
        name: '中国本土',
        description: '中国地域は上海・北京・深圳を中心に、広域ITサービスと現地対応を支援します。',
        offices: [
          {
            title: '上海サービスセンター',
            addressLines: [
              'Room 1003-1, Guangming Real Estate Building',
              'No. 199 Xizang North Road',
              'Jing\'an District, Shanghai, China',
              '中国上海市静安区西藏北路199号 光明地产大厦1003-1室'
            ],
            coordinates: { lat: 31.2411, lng: 121.4754 }
          },
          {
            title: '北京サービスセンター',
            addressLines: [
              'No. 18, Jingjia Road',
              'Yanqi Town, Huairou District',
              'Beijing, China',
              '北京市怀柔区雁栖镇京加路18号'
            ],
            coordinates: { lat: 40.4018, lng: 116.6766 }
          },
          {
            title: '深圳サービスセンター',
            addressLines: [
              'Unit 55, Room 1407, Building B, Phase 1',
              'Tian\'an Innovation Technology Plaza',
              'No. 4 Tairan Road, Futian District, Shenzhen, China',
              '深圳市福田区天安创新科技广场一期B座1407-55'
            ],
            coordinates: { lat: 22.5412, lng: 114.0539 }
          }
        ],
        workingHours: '月曜日～金曜日 9:00-18:00'
      },
      hongkong: {
        name: '香港',
        description: '香港サービスセンターは国際案件連携と地域密着型サポートの窓口として機能します。',
        offices: [
          {
            title: '香港サービスセンター',
            addressLines: [
              'Room A, 1/F., Arthur Commercial Building,',
              '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong',
              '香港九龍油麻地鴉打街33号 雅達商業大廈1樓A室'
            ],
            coordinates: { lat: 22.3070, lng: 114.1714 }
          }
        ],
        workingHours: '月曜日～金曜日 9:30-18:30'
      },
      taiwan: {
        name: '台北',
        description: '台湾地域のサービス対応は可能ですが、サービスセンター情報は確認待ちです。',
        offices: [],
        workingHours: '月曜日～金曜日 9:00-18:00'
      },
      singapore: {
        name: 'シンガポール',
        description: 'シンガポールは東南アジア地域の拠点として、案件連携と商談対応を担います。',
        offices: [
          {
            title: 'シンガポールサービスセンター',
            addressLines: [
              '10 ANSON ROAD',
              '#27-18',
              'INTERNATIONAL PLAZA',
              'SINGAPORE (079903)'
            ],
            coordinates: { lat: 1.2752, lng: 103.8453 }
          }
        ],
        workingHours: '月曜日～金曜日 9:00-18:00'
      },
      japan: {
        name: '日本',
        description: '日本サービスセンターは現地顧客対応とクロスボーダー案件の支援を行います。',
        offices: [
          {
            title: '日本サービスセンター',
            addressLines: [
              '208, 2-9-17 HIGASHITABATA, KITA-KU,',
              'TOKYO 114-0013, JAPAN',
              '東京都北区東田端二丁目9番17-208号'
            ],
            coordinates: { lat: 35.7412, lng: 139.7600 }
          }
        ],
        workingHours: '月曜日～金曜日 9:00-18:00'
      },
      korea: {
        name: 'ソウル',
        description: '韓国地域のサービス対応は可能ですが、サービスセンター情報は確認待ちです。',
        offices: [],
        workingHours: '月曜日～金曜日 9:00-18:00'
      }
    }
  },
  
  // 即時コミュニケーション
  instantCommunication: {
    title: '即時コミュニケーション',
    subtitle: '複数チャネルで迅速な連絡、専門チームがいつでもサービスを提供',
    liveChat: {
      title: 'ライブチャット',
      description: '営業時間内に即時対応',
      button: 'チャット開始',
      hours: '月～金 9:00-18:00'
    },
    wechat: {
      title: 'WeChat Work',
      description: 'QRコードをスキャンしてWeChat Workを追加',
      qrcode: 'QRコードをスキャンして追加',
      qrcodeAlt: 'WeChat Workの連絡用QRコード'
    },
    whatsapp: {
      title: 'WhatsApp',
      description: '国際ビジネスの迅速な連絡',
      button: 'メッセージを送信'
    }
  },
  
  // フォームセクション
  formSection: {
    consultation: {
      tab: 'ビジネスお問い合わせ',
      title: 'ビジネスお問い合わせ',
      description: 'お問い合わせフォームにご記入いただければ、専門チームが24時間以内にご連絡し、カスタマイズされたITソリューションとプロジェクトの提案を提供いたします。',
      benefits: {
        analysis: '無料の要件分析とソリューション提案',
        demo: '専門チームによる1対1サービス',
        response: '24時間以内の迅速な対応',
        privacy: 'プライバシー情報の保護'
      }
    },
    partnership: {
      tab: 'ビジネスパートナーシップ',
      title: 'ビジネスパートナーシップ',
      description: 'チャネルパートナー、技術提携、ソリューションインテグレーターの皆様との協力を歓迎し、共にビジネス市場を拡大し、相互利益を実現します。',
      benefits: {
        channel: 'チャネルパートナープログラム',
        tech: '技術提携と統合',
        solution: 'ソリューション共同開発',
        support: '包括的なサポートとトレーニング'
      }
    },
    inquiryType: {
      label: 'お問い合わせタイプ',
      partnershipLabel: 'パートナーシップタイプ',
      placeholder: 'タイプを選択してください',
      consultation: {
        solution: 'ソリューション相談',
        product: '製品機能',
        pricing: '価格と見積もり',
        demo: '製品デモ',
        support: '技術サポート'
      },
      partnership: {
        channel: 'チャネルパートナーシップ',
        technology: '技術提携',
        integration: 'ソリューション統合',
        consulting: 'コンサルティングサービス',
        other: 'その他のパートナーシップ'
      }
    },
    region: {
      label: 'サービス地域',
      placeholder: 'サービス地域を選択してください',
      china: '中国本土',
      hongkong: '香港',
      taiwan: '台湾',
      singapore: 'シンガポール',
      japan: '日本',
      korea: '韓国'
    }
  },
  
  info: {
    title: '連絡先情報',
    address: {
      title: 'サービスセンター住所',
      content: '中国上海市静安区西藏北路199号 光明地产大厦1003-1室'
    },
    phone: {
      title: '電話番号',
      content: '+86 21 8765 4321'
    },
    email: {
      title: 'メールアドレス'
    },
    hours: {
      title: '営業時間',
      content: '月曜日～金曜日 9:00-18:00'
    }
  },
  
  social: {
    title: 'フォローする'
  },
  
  form: {
    title: 'メッセージを送信',
    companyName: '会社名',
    companyNamePlaceholder: '会社名を入力してください',
    contactName: '担当者名',
    contactNamePlaceholder: 'お名前を入力してください',
    position: '役職',
    positionPlaceholder: '役職を入力してください',
    email: 'メールアドレス',
    emailPlaceholder: 'メールアドレスを入力してください',
    phone: '電話番号',
    phonePlaceholder: '電話番号を入力してください',
    industry: '業界',
    industryPlaceholder: '業界を選択してください',
    industries: {
      technology: 'テクノロジー',
      finance: '金融',
      healthcare: 'ヘルスケア',
      education: '教育',
      manufacturing: '製造業',
      retail: '小売業',
      other: 'その他'
    },
    companySize: '会社規模',
    companySizePlaceholder: '会社規模を選択してください',
    employees: '名',
    interestedServices: '興味のあるサービス',
    serviceOptions: {
      ticketSystem: 'スマートチケットシステム',
      aiSolutions: 'AIソリューション',
      dataAnalytics: 'データ分析',
      consulting: 'ITコンサルティング'
    },
    budget: 'プロジェクト予算',
    budgetPlaceholder: '予算範囲を選択',
    budgetOptions: {
      under50k: '5万元未満',
      range50k100k: '5万元から10万元',
      range100k500k: '10万元から50万元',
      range500k1m: '50万元から100万元',
      over1m: '100万元以上'
    },
    message: 'プロジェクト説明',
    messagePlaceholder: 'プロジェクトの要件と期待について詳しく説明してください',
    submit: 'お問い合わせを送信',
    submitting: '送信中'
  },
  
  success: {
    title: '送信完了',
    message: 'お問い合わせを受け付けました。24時間以内にご連絡いたします。',
    close: 'OK'
  },
  
  regions: {
    title: 'サービス地域',
    selectRegion: '地域を選択',
    allRegions: 'すべての地域'
  }
}
